export class CsGuid {
  public static empty: string = '00000000-0000-0000-0000-000000000000';
}
